import { render, staticRenderFns } from "./TrainingQuizQuestionTypeRanking.vue?vue&type=template&id=400ac171&"
import script from "./TrainingQuizQuestionTypeRanking.vue?vue&type=script&lang=js&"
export * from "./TrainingQuizQuestionTypeRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports